import { app } from '../../../../bootstrap/core';
import { partnerDetailItemComponent } from './partnerDetailItem.component';

app.component('partnerDetail', partnerDetailItemComponent);